import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import api, { formatApiError } from "../../lib/api";

export function EmailReceiptButton({ receipt, onSent, className = "", copy = "customer" }) {
  const [busy, setBusy] = useState(false);
  const email = receipt.shipper?.email;

  const send = async () => {
    if (!email) { toast.error("Add the shipper's email to this receipt first (Edit → Shipper → Email)"); return; }
    setBusy(true);
    try {
      const { buildReceiptPdf } = await import("../../lib/receiptPdf");
      const pdf = await buildReceiptPdf(receipt, copy);
      const fd = new FormData();
      fd.append("file", pdf, `${receipt.receipt_number}.pdf`);
      fd.append("site_url", window.location.origin);
      const { data } = await api.post(`/receipts/${receipt.id}/email`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`Receipt emailed to ${data.emailed_to}`);
      onSent?.(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" onClick={send} disabled={busy} title={email ? `Email PDF to ${email}` : "No shipper email on this receipt"}
      className={`inline-flex items-center gap-1 disabled:opacity-60 ${className}`} data-testid={`receipt-email-${receipt.receipt_number}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Mail className="h-3.5 w-3.5" />} {busy ? "Sending..." : "Email PDF"}
    </button>
  );
}
